import * as URI from 'urijs';

/**
 * @const {string} A URL in the form: https://(app|staging).talis.com/player#/modules/<module_id>/resources/<resource_id>
 */
const PROD_PLAYER_URL_REGEX =
  /^https:\/\/(app)\.(talis\.com)\/([^/]+)\/([^/]+\/)?player#\/modules\/([^/]+)\/resources\/([^/]+)$/;
const LOCAL_PLAYER_URL_REGEX =
  /^http:\/\/(elevate\.talis)\.(local:3000)\/([^/]+)\/([^/]+\/)?player#\/modules\/([^/]+)\/resources\/([^/]+)$/;

export class PlayerResourceUtilsClass {
  isPlayerUrl(url: string): boolean {
    return url &&
      (url.match(PROD_PLAYER_URL_REGEX) || url.match(LOCAL_PLAYER_URL_REGEX))
      ? true
      : false;
  }

  getThumbnailUrl(playerResourceUrl: string): string {
    if (!playerResourceUrl) {
      return undefined;
    }
    const parts =
      playerResourceUrl.match(PROD_PLAYER_URL_REGEX) ||
      playerResourceUrl.match(LOCAL_PLAYER_URL_REGEX);

    if (!parts) {
      return undefined;
    }

    const [, , , , , , resource] = parts;

    const playerUri = new URI(playerResourceUrl);

    return new URI(playerUri.origin())
      .segment(['resources', resource, 'thumbnail'])
      .toString();
  }
}

export const PlayerResourceUtils = new PlayerResourceUtilsClass();
